import { render } from "./IPhoneFoldSection.vue?vue&type=template&id=e5d0d4dc&scoped=true"
import script from "./IPhoneFoldSection.vue?vue&type=script&lang=js"
export * from "./IPhoneFoldSection.vue?vue&type=script&lang=js"

import "./IPhoneFoldSection.vue?vue&type=style&index=0&id=e5d0d4dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d0d4dc"]])

export default __exports__